<template>
  <div class="add-expert">
    <p style="font-size: 16px; background-color: #fff;padding: 10px;">报名服务单位信息</p>
    <van-field readonly input-align="right" clickable name="city" required :value="type" label="报名服务单位类型"
      placeholder="请选择报名服务单位类型" @click="showTypeId = true" error-message-align="right"
      :error-message="validate.fieldMsg.contactCity" />
    <van-popup v-model="showTypeId" position="bottom">
      <van-picker show-toolbar :columns="[
        {
          text: '正式报名服务单位',
          value: 0
        },
      ]" @confirm="onConfirmTypeId" @cancel="showTypeId = false" />
    </van-popup>

    <van-field readonly input-align="right" clickable name="city" required :value="typeSub" label="机构分类"
      placeholder="请选择机构分类" @click="showTypeSub = true" error-message-align="right"
      :error-message="validate.fieldMsg.contactCity" />
    <van-popup v-model="showTypeSub" position="bottom">
      <van-picker show-toolbar :columns="[
        {
          text: '机构',
          value: 1
        },
        {
          text: '学校',
          value: 2
        },

      ]" @confirm="onConfirmTypeSub" @cancel="showTypeSub = false" />
    </van-popup>
    <van-field clickable name="name" required label="单位名称" placeholder="请输入报名服务单位名称" v-model="formData.name"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.name" />
    <van-field clickable name="tel" required label="手机号码" :disabled="inviteStatus == 1" placeholder="请输入手机号码"
      v-model="formData.tel" input-align="right" error-message-align="right" :error-message="validate.fieldMsg.tel"
      @change="validate.tel('tel')">
      <template #button v-if="this.inviteStatus != 1">
        <span size="small" round @click="sendCode" style="color: #6cdd8f">{{ sendClip ? "发送验证码" : `${second}s` }}</span>
      </template>
    </van-field>
    <van-field clickable name="code" v-if="this.inviteStatus != 1" required label="验证码" placeholder="请输入验证码"
      v-model="formData.code" input-align="right" error-message-align="right" :error-message="validate.fieldMsg.code" />
    <van-field clickable name="password" v-if="this.inviteStatus != 1" required label="登录密码" placeholder="请输入登录密码"
      v-model="formData.password" input-align="right" error-message-align="right"
      :error-message="validate.fieldMsg.password" @change="validate.pwd('password')" />
    <van-field readonly input-align="right" clickable name="city" required :value="city" label="单位地址"
      placeholder="请选择地址" @click="showArea = true" error-message-align="right"
      :error-message="validate.fieldMsg.contactCity" />
    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="areaConfirm" @cancel="showArea = false" />
    </van-popup>
    <van-field clickable name="contactAddress" required v-model="formData.contactAddress" label="详细地址"
      placeholder="请输入详细地址" input-align="right" error-message-align="right"
      :error-message="validate.fieldMsg.contactAddress" />
    <van-field clickable name="license" required label="执照编码" placeholder="请输入执照编码" v-model="formData.license"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.license" />
    <van-field clickable name="license" required label="执照名称" placeholder="请输入执照名称" v-model="formData.licenseName"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.license" />
      
    <van-field label-class="affixs-label" required>
      <template #label>
        <span class="custom-title" error-message-align="right"
          :error-message="validate.fieldMsg.credentialsImg">单位资质</span>
        <span class="custom-tit" style="margin-left: 10px;">(jpg/png格式最多一张，每张不超过1M)</span>
      </template>
    </van-field>
    <div class="expert-userImg">
      <van-uploader :before-delete="credentialsImgBeforeDel" v-model="credentialsImg" :max-count="1"
        :before-read="compressUploadBeforeReadcredentialsImg" />
    </div>
    <!-- <van-field label-class="affixs-label" required>
      <template #label>
        <span class="custom-title" error-message-align="right" :error-message="validate.fieldMsg.logo">单位Logo</span>
        <span class="custom-tit" style="margin-left: 10px;">(jpg/png格式最多一张，每张不超过1M)</span>
      </template>
    </van-field>
    <div class="expert-userImg">
      <van-uploader :before-delete="logoBeforeDel" v-model="logo" :max-count="1"
        :before-read="compressUploadBeforeReadlogo" />
    </div> -->
    <van-field clickable name="synopsis" required v-model="formData.synopsis" autosize rows="4" type="textarea"
      maxlength="300" label="单位简介" placeholder="请输入简介" show-word-limit input-align="right"
      :error-message="validate.fieldMsg.synopsis" error-message-align="right" :style="{ marginBottom: '20px' }" />

    <p style="font-size: 16px; background-color: #fff;padding: 10px;">报名服务单位联系人</p>

    <van-field clickable name="personCharge" required label="真实姓名" placeholder="请输入真实姓名" v-model="formData.personCharge"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.personCharge" />
    <van-field clickable name="contactsTel" required label="手机号码" placeholder="请输入手机号码" v-model="formData.contactsTel"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.contactsTel" />
    <van-field clickable name="contactEmail" required label="联系邮箱" placeholder="请输入联系邮箱" v-model="formData.contactEmail"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.contactEmail" />
    <van-field clickable name="wxAccounts" required label="微信号码" placeholder="请输入微信号码" v-model="formData.wxAccounts"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.wxAccounts" />



    <div class="create">
      <van-button size="large" @click="commitInfo" color="linear-gradient(to right, #5DD682, #5AFF8E)">提交</van-button>
    </div>
    <Crop :fixed="false" :popup.sync="compressShowlogo" :img="compressImglogo" @close="cancelUploadLogo" @getImageData="uploadlogo" />
    <Crop :fixed="false" :popup.sync="compressShowcredentialsImg" :img="compressImgcredentialsImg" @close="cancelUploadCredentialsImg"
      @getImageData="uploadcredentialsImg" />

  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import {
  getInstitutionTelCode,
  commitInviteInstitution,
  getInstitutionInfo,
} from "@/utils/api/invite";

import { Dialog } from 'vant';

import { uploadImg } from "@/utils/api/user";
import { checkUploadFile } from "@/utils/tool";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
  mixins: [validate],
  components: {
    Crop
    // SignTitle
  },
  data() {
    return {
      showTypeId: false,
      showTypeSub: false,
      type: '',
      typeSub: '',
      sendClip: true,
      second: 60,
      formData: {
        name: '',
        tel: '',
        code: '',
        password: '',
        contactAddress: '',
        contactArea: '',
        contactCity: '',
        contactProvince: '',
        logo: '',
        credentialsImg: '',
        synopsis: '',
        personCharge: '',
        contactsTel: '',
        contactEmail: '',
        wxAccounts: '',
        inviteCode: '',
        license: '',
        zoneId: '',
        licenseName:'',
      },


      inviteStatus: 0,

      // 省市区
      city: "",
      // 区域树
      areaList,
      // 显示区域选择
      showArea: false,
      // 头像
      logo: [],
      credentialsImg: [],
      // 专业列表
      majorList: [],
      // 活动列表
      activityList: [],
      // 性别
      sex: null,
      // 显示选择框
      showPicker: false,
      // 所选专业
      major: null,
      // 所选专业
      majorSelectList: [],
      // 所选活动
      activity: null,
      // 所选活动
      activityIdList: [],
      // 显示选择
      majorPicker: false,
      // 显示活动选择
      activityPicker: false,
      // 标签
      tags: [],
      mode: 0, // 0新增，1修改
      compressShowlogo: false,
      compressShowcredentialsImg: false,
      compressImglogo: "",
      compressImgcredentialsImg: "",

    };
  },
  mounted() {
    this.validate.setFormDataKey("formData");

    this.formData.inviteCode = this.$route.query.inviteCode
    this.formData.zoneId = this.$route.query.zoneId
    this.getInfo();
  },
  methods: {
    // 获取邀请信息
    getInfo() {
      getInstitutionInfo({ code: this.formData.inviteCode }).then((res) => {
        if (res.success) {
          console.log(res.data.inviteStatus)
          this.inviteStatus = res.data.inviteStatus
          var data = res.data
          if (this.inviteStatus == 1) {
            this.formData = {
              typeId: data.typeId,
              name: data.name,
              tel: data.tel,
              // 详情不赋值密码
              // password: data.password,
              contactAddress: data.contactAddress,
              contactArea: data.contactArea,
              contactCity: data.contactCity,
              contactProvince: data.contactProvince,
              logo: data.logo,
              credentialsImg: data.credentialsImg,
              synopsis: data.synopsis,
              personCharge: data.personCharge,
              contactsTel: data.contactsTel,
              contactEmail: data.contactEmail,
              wxAccounts: data.wxAccounts,
              contactEmail: data.contactEmail,
              inviteCode: this.$route.query.inviteCode,
              license: data.license,
              zoneId: data.zoneId,
              typeSub: data.typeSub,
              licenseName: data.licenseName,
            }
            this.credentialsImg = [{
              url: data.credentialsImg,
              status: 'done'
            }]
            this.type = '正式报名服务单位'
            if (this.formData.typeSub == 1) {
              this.typeSub = '学校'
            }
            if (this.formData.typeSub == 2) {
              this.typeSub = '机构'
            }
            this.city = data.contactProvince + data.contactCity + data.contactArea
          }

        }
      });
    },

    // 报名服务单位回执 类型
    onConfirmTypeId(item) {
      this.type = item.text;
      this.formData.typeId = item.value;
      this.showTypeId = false;
    },
    // 报名服务单位回执 分类
    onConfirmTypeSub(item) {
      this.typeSub = item.text;
      this.formData.typeSub = item.value;
      this.showTypeSub = false;
    },
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      if (!(this.formData.tel && this.formData.tel.length == 11)) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      getInstitutionTelCode({ tel: this.formData.tel }).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },

    // 删除照片
    logoBeforeDel() {
      this.formData.logo = null;
      return true;
    },
    // 删除照片
    credentialsImgBeforeDel() {
      this.formData.credentialsImg = null;
      return true;
    },

    cancelUploadLogo() {
      this.compressShowlogo = false;
      this.logo = [];
    },
    cancelUploadCredentialsImg() {
      this.compressShowcredentialsImg = false;
      this.credentialsImg = [];
    },
    // 上传logo
    async uploadlogo(file) {
      const pass = checkUploadFile({ file, size: 3 }, (err) => {
        this.$root.$toast.fail(err);
        this.logo = [
          {
            url: "",
            message: "图片大于3m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.logo = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.logo = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.logo = url;
      } else {
        this.logo = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },
    // 上传执照
    async uploadcredentialsImg(file) {
      const pass = checkUploadFile({ file, size: 3 }, (err) => {
        this.$root.$toast.fail(err);
        this.credentialsImg = [
          {
            url: "",
            message: "图片大于3m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.credentialsImg = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.credentialsImg = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.credentialsImg = url;
      } else {
        this.credentialsImg = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },


    // 压缩上传预处理
    compressUploadBeforeReadcredentialsImg(file) {
      this.compressImgcredentialsImg = URL.createObjectURL(file);
      this.credentialsImg = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShowcredentialsImg = true;
    },
    // 压缩上传预处理
    compressUploadBeforeReadlogo(file) {
      this.compressImglogo = URL.createObjectURL(file);
      this.logo = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShowlogo = true;
    },

    // 区域确定
    areaConfirm(values) {
      this.city = `${values[0].name} ${values[1].name} ${values[2].name}`;
      this.formData.contactProvince = values[0].name;
      this.formData.contactCity = values[1].name;
      this.formData.contactArea = values[2].name;
      this.showArea = false;
    },

    commitInfo() {

      if (this.formData.typeId !== 0 && this.formData.typeId !== 1) {
        this.$root.$toast.fail("请选择报名服务单位类型");
        return;
      }
      if (this.formData.typeSub !== 1 && this.formData.typeSub !== 2) {
        this.$root.$toast.fail("请选择机构分类");
        return;
      }


      if (!this.formData.name) {
        this.$root.$toast.fail("请填写单位名称");
        return;
      }

      if (!(this.formData.tel && this.formData.tel.length == 11)) {
        this.$root.$toast.fail("请填写正确手机号");
        return;
      }

      if (!this.formData.code && this.inviteStatus != 1) {
        this.$root.$toast.fail("请填写验证码");
        return;
      }

      if (!this.formData.password && this.inviteStatus != 1) {
        this.$root.$toast.fail("请填写登录密码");
        return;
      }


      if (!this.formData.contactArea) {
        this.$root.$toast.fail("请选择单位地址");
        return;
      }
      if (!this.formData.contactAddress) {
        this.$root.$toast.fail("请填写详细地址");
        return;
      }
      if (!this.formData.license) {
        this.$root.$toast.fail("请填写执照编码");
        return;
      }




      if (!this.formData.credentialsImg) {
        this.$root.$toast.fail("请上传单位资质");
        return;
      }
      // if (!this.formData.logo) {
      //   this.$root.$toast.fail("请上传单位Logo");
      //   return;
      // }
      if (!this.formData.synopsis) {
        this.$root.$toast.fail("请填写简介");
        return;
      }
      if (!this.formData.personCharge) {
        this.$root.$toast.fail("请填写联系人姓名");
        return;
      }

      if (!(this.formData.contactsTel && this.formData.contactsTel.length == 11)) {
        this.$root.$toast.fail("请正确填写联系人手机号码");
        return;
      }

      if (!this.formData.contactEmail) {
        this.$root.$toast.fail("请填写联系人邮箱");
        return;
      }
      if (!this.formData.wxAccounts) {
        this.$root.$toast.fail("请填写联系人微信号码");
        return;
      }

      var data = JSON.parse(JSON.stringify(this.formData));
      if ((data.tel || '').indexOf('*') > -1) {
        delete data.tel
      }
      if ((data.contactsTel || '').indexOf('*') > -1) {
        delete data.contactsTel
      }


      commitInviteInstitution({
        url: this.inviteStatus == 1 ? 'inviteInstitution/applyInviteUpdate' : "inviteInstitution/applyInvite",
        ...data

      }).then(res => {
        console.log(res)
        if (res.success) {
          this.$root.$toast.success('您已提交成功,请等待管理员审核');
        }
      })
    },



  },

};
</script>

<style lang="scss" scoped>
.add-expert {
  overflow: hidden;
  background: #f2f2f2;
  min-height: 100vh;
  .tags {
    .van-tag {
      height: 32px;
      margin-left: 3px;
      margin-bottom: 3px;
      border-radius: 4px;
      border: #f2f2f2;
      min-width: 60px;
      background-color: #ecf5ff;
      color: #666;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      line-height: 26px;
    }
  }

  .create {
    margin: 0 auto;
    width: 254px;
    margin-top: 40px;
    margin-bottom: 60px;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.add-expert {
  text-align: left;

  .van-cell {
    &::after {
      border: none;
    }
  }

  .van-uploader {
    @include from-upload-style;
  }

  .custom-title {
    color: #646566;
  }

  .custom-tit {
    font-size: 12px;
    color: #ccc;
  }

  .expert-userImg {
    text-align: left;
    padding-top: 10px;
    padding-left: 10px;
    background: #fff;
  }

  .custom-span {
    color: #ccc;
  }

  .affixs-label {
    width: unset;

    &+.van-field__value {
      display: none;
    }
  }
}
</style>
